import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useTemplateStore } from 'stores';
import type { TemplateType } from 'types';
import { templateMigrator } from '../helpers';
import { getTemplate } from '../requests';
import type { GetTemplateRequestType } from '../types';

export const useGetTemplate = (
  {
    pathParams: { templateId },
  }: {
    pathParams: GetTemplateRequestType['pathParams'];
  },
  options?: {
    enabled?: boolean;
  },
) => {
  const setTemplate = useTemplateStore(state => state.setTemplate);

  return useQuery({
    queryKey: [
      API_QUERY_KEYS.template,
      {
        templateId: Number(templateId),
      },
    ],
    queryFn: () =>
      getTemplate({
        pathParams: { templateId },
      }).then(templateMigrator),
    ...options,
    onSuccess: (data: TemplateType) => {
      setTemplate(data);
    },
  });
};
